import React from 'react';
import { getSectionContent } from '../services/contentService';
import './FromIdeaToImpact.css';

const FromIdeaToImpact = ({ content = [] }) => {
  // Get from-idea-to-impact section content
  const section = getSectionContent(content, 'from-idea-to-impact');
  
  const defaultTitle = 'From Idea to Impact - We are with You Every Step';
  const defaultDescription = 'We believe Africa most powerful resource is its young people. We equip them with the skills, tools, and opportunities to turn ideas into solutions that transform communities and shape a better future for all.';
  
  const title = section?.content?.mainTitle || defaultTitle;
  const description = section?.content?.description || defaultDescription;

  return (
    <section className="from-idea-to-impact">
      <div className="container">
        <div className="content">
          <h2 className="section-title">
            {title}
          </h2>
          <p className="section-description">
            {description}
          </p>
        </div>
      </div>
    </section>
  );
};

export default FromIdeaToImpact;